import { KOREAN_CURRENCY_MAP, type Currency } from '../types/newFinance';

/**
 * 자동 파싱 결과 타입
 */
export interface ParseResult {
  name: string;
  amount: number;
  currency: Currency;
  isValid: boolean;
}

/**
 * 재정 입력 자동 파싱 함수
 * 예: "김철수10000ㄷ" → { name: "김철수", amount: 10000, currency: "EUR" }
 */
export const parseFinanceInput = (input: string): ParseResult => {
  if (!input || input.trim() === '') {
    return { name: '', amount: 0, currency: 'HUF', isValid: false };
  }

  const trimmedInput = input.trim();
  
  // 1. 마지막 문자가 한글 통화 코드인지 확인
  const lastChar = trimmedInput.slice(-1);
  const currency: Currency = KOREAN_CURRENCY_MAP[lastChar] || 'HUF';
  
  // 2. 통화 코드 제거한 나머지 부분
  const withoutCurrency = currency === 'HUF' ? trimmedInput : trimmedInput.slice(0, -1);
  
  // 3. 숫자 추출
  const numberMatch = withoutCurrency.match(/\d+/g);
  const amount = numberMatch ? parseInt(numberMatch.join(''), 10) : 0;
  
  // 4. 이름 추출 (숫자 제거)
  const name = withoutCurrency.replace(/\d+/g, '').trim();
  
  // 5. 유효성 검증
  const isValid = name.length > 0 && amount > 0;
  
  return {
    name,
    amount,
    currency,
    isValid
  };
};

/**
 * 파싱 예시와 도움말 생성
 */
export const getParsingHelp = (): string[] => {
  return [
    '입력 예시:',
    '• 김철수10000 → 김철수, 10000 HUF',
    '• 이영희5000ㄷ → 이영희, 5000 EUR', 
    '• 박민수20000ㅕ → 박민수, 20000 USD',
    '• 정수진15000ㅏ → 정수진, 15000 KRW',
    '',
    '입력 후 스페이스바를 누르세요!'
  ];
};

/**
 * 통화별 포맷팅
 */
export const formatCurrency = (amount: number, currency: Currency): string => {
  const symbols: Record<Currency, string> = {
    HUF: 'Ft',
    EUR: '€',
    USD: '$',
    KRW: '₩',
    GBP: '£',
    CAD: 'CA$'
  };
  
  return `${amount.toLocaleString()} ${symbols[currency]}`;
};
